import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/repertory/query', {
  name: 'RepertoryQuery',
  meta: {
    nav: [
      { title: '库存详情', id: 10 },
      { title: '库存概览', id: 20 },
      { title: '库存流水', id: 30 },
    ],
  },
});
